import { useEffect, useState } from "react";

export default function BackTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={
        "fixed bottom-6 right-5 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-foreground-900 text-white shadow-none transition " +
        (show ? "opacity-100" : "opacity-0 pointer-events-none")
      }
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}